import React from "react";
import "./skills.css";
import Reveal from "../motion/Reveal";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, stagger } from "../../motion";

const groups = [
  {
    n: "01",
    title: "Frameworks",
    note: "What I build products with",
    items: ["React Native", "React.js", "Angular", "Electron.js"],
  },
  {
    n: "02",
    title: "Languages & markup",
    note: "The foundation underneath",
    items: ["TypeScript", "JavaScript", "Python", "HTML", "CSS"],
  },
  {
    n: "03",
    title: "Backend & data",
    note: "APIs and data that stay reliable",
    items: ["Node.js", "Express.js", "MongoDB", "PostgreSQL", "Firebase", "Socket.IO"],
  },
  {
    n: "04",
    title: "Mobile & state",
    note: "Client architecture on device",
    items: ["Redux Toolkit", "Google Vision API", "Push notifications", "Deep linking", "Geofencing"],
  },
  {
    n: "05",
    title: "Tooling & workflow",
    note: "How the work gets shipped",
    items: ["Git", "GitHub", "Jira", "Trello", "Android Studio", "Agile / Scrum"],
  },
  {
    n: "06",
    title: "Delivery",
    note: "What happens after the build",
    items: ["App Store", "Play Store", "REST APIs", "Code reviews", "Project management"],
  },
];

const marquee = [
  "React Native",
  "React.js",
  "Angular",
  "Electron.js",
  "Node.js",
  "Python",
  "Firebase",
  "Redux Toolkit",
  "PostgreSQL",
  "MongoDB",
  "Google Vision",
  "Socket.IO",
  "Jira",
  "Agile",
];

const Skills = () => {
  const reduce = useReducedMotion();

  return (
    <section id="skills" className="section skills">
      <div className="container">
        <Reveal>
          <p className="section__label">
            <span>04</span> — Capabilities
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="section__title">The toolkit behind the work.</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="section__lead">
            Frameworks and tools I reach for daily, grouped by the job they do.
          </p>
        </Reveal>

        <motion.div
          className="skills__grid"
          variants={stagger(0.07)}
          initial={reduce ? false : "hidden"}
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
        >
          {groups.map((group) => (
            <motion.article key={group.n} variants={fadeUp}>
              <div className="skills__head">
                <h3>{group.title}</h3>
                <span className="mono">{group.n}</span>
              </div>
              <p>{group.note}</p>
              <ul>
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </motion.article>
          ))}
        </motion.div>
      </div>

      <div className="skills__marquee" aria-hidden="true">
        <div className="skills__track">
          {[...marquee, ...marquee].map((item, i) => (
            <span key={`${item}-${i}`}>
              {item} <i>◆</i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
